/**
 * Reads a Blob's bytes, falling back to FileReader where `Blob.arrayBuffer()` is missing (older
 * WebKit, and jsdom — where a Blob rebuilt from persisted bytes has no `arrayBuffer`).
 */
export function readBlobBytes(payload: Blob): Promise<ArrayBuffer> {
	if (typeof payload.arrayBuffer === "function") return payload.arrayBuffer();
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = () =>
			reader.result instanceof ArrayBuffer ? resolve(reader.result) : reject(new Error("Could not read payload bytes"));
		reader.onerror = () => reject(reader.error ?? new Error("Could not read payload bytes"));
		reader.readAsArrayBuffer(payload);
	});
}
